<template>
  <b-modal
    id="suspensoes-mit"
    :ref="'suspensoes-mit'"
    :title="'Suspensões da Apuração MIT'"
    no-close-on-backdrop
    no-stacking
    scrollable
    size="lg"
    :dialog-class="'suspensoes-modal-custom'"
    @hidden="fecharModal"
  >
    <div
      v-if="carregando"
      class="d-flex align-items-center justify-content-center p-4 text-muted"
    >
      <b-spinner
        small
        class="mr-2"
      />
      Carregando suspensões...
    </div>
    <div v-else>
      <!-- Cabeçalho com empresa e período -->
      <div class="mb-3 font-medium-1 p-3 bg-light border rounded">
        <strong>{{ empresaNome || 'Empresa' }}</strong>
        <span v-if="periodoApuracao"> | Período da Apuração: {{ periodoApuracao }}</span>
      </div>

      <!-- Lista de Suspensões -->
      <div v-if="suspensoes && suspensoes.length > 0">
        <h5 class="mb-3">
          Suspensões Encontradas ({{ suspensoes.length }})
        </h5>

        <b-card
          v-for="(suspensao, index) in suspensoes"
          :key="index"
          class="mb-2"
          border-variant="primary"
        >
          <b-card-header class="bg-primary">
            <h6 class="mb-0 text-white">
              <font-awesome-icon
                :icon="faBan"
                class="mr-2"
              />
              Suspensão {{ index + 1 }}
            </h6>
          </b-card-header>

          <b-card-body>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Tipo:">
                  <b-badge variant="primary">
                    {{ obterDescricaoTipo(suspensao.tipo) }}
                  </b-badge>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Motivo:">
                  <b-badge variant="secondary">
                    {{ obterDescricaoMotivo(suspensao.motivo) }}
                  </b-badge>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group label="Com Depósito:">
                  <b-badge :variant="suspensao.comDeposito ? 'success' : 'danger'">
                    {{ suspensao.comDeposito ? 'Sim' : 'Não' }}
                  </b-badge>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Processo de Terceiro:">
                  <b-badge :variant="suspensao.processoTerceiro ? 'warning' : 'success'">
                    {{ suspensao.processoTerceiro ? 'Sim' : 'Não' }}
                  </b-badge>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="suspensao.numeroProcesso">
              <b-col cols="12">
                <b-form-group label="Número do Processo:">
                  <b-form-input
                    :value="suspensao.numeroProcesso"
                    readonly
                    class="font-weight-bold"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="suspensao.dataDecisao">
              <b-col cols="6">
                <b-form-group label="Data da Decisão:">
                  <b-form-input
                    :value="formatarData(suspensao.dataDecisao)"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Vara Judiciária:">
                  <b-form-input
                    :value="obterDescricaoVara(suspensao.varaJudiciaria)"
                    readonly
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="suspensao.codigoMunicipioSj">
              <b-col cols="12">
                <b-form-group label="Código do Município:">
                  <b-form-input
                    :value="suspensao.codigoMunicipioSj"
                    readonly
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Débitos Suspensos -->
            <div
              v-if="suspensao.debitosSuspensos && suspensao.debitosSuspensos.length > 0"
              class="mt-3"
            >
              <h6 class="text-primary">
                <font-awesome-icon
                  :icon="faMoneyBill"
                  class="mr-2"
                />
                Débitos Suspensos
              </h6>
              <b-table
                :items="suspensao.debitosSuspensos"
                :fields="camposDebitosSuspensos"
                striped
                hover
                small
                class="mt-2"
              >
                <template #cell(valorSuspenso)="data">
                  <span class="font-weight-bold text-success">
                    {{ formatarValor(data.value) }}
                  </span>
                </template>
              </b-table>

              <!-- Total dos débitos suspensos -->
              <div class="d-flex justify-content-end mt-2">
                <div class="p-2 bg-success text-white rounded font-weight-bold">
                  Total Suspenso: {{ formatarValor(calcularTotalSuspenso(suspensao.debitosSuspensos)) }}
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <!-- Mensagem quando não há suspensões -->
      <div
        v-else
        class="text-center text-muted p-4"
      >
        <font-awesome-icon
          :icon="faInfoCircle"
          size="2x"
          class="mb-3 text-primary"
        />
        <h5>Nenhuma suspensão encontrada</h5>
      </div>
    </div>

    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="fecharModal"
        >
          Fechar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<style lang="scss">
@import '../../styles/suspencoes.scss';
</style>

<script>
import service from '@app/mit-apuracao/services/mitApuracaoService'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBan, faMoneyBill, faInfoCircle } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'SuspensoesMitApuracao',
  components: {
    FontAwesomeIcon,
  },
  props: {
    empresaNome: { type: String, default: '' },
    empresaId: { type: Number, required: true },
    idApuracao: { type: Number, required: true },
    periodoApuracao: { type: String, default: '' },
  },
  data() {
    return {
      dados: null,
      suspensoes: [],
      carregando: false,
      pagina: 1,
      tamanhoPagina: 50,
      faBan,
      faMoneyBill,
      faInfoCircle,
      camposDebitosSuspensos: [
        {
          key: 'idDebitoSuspenso',
          label: 'ID Débito',
          sortable: true,
        },
        {
          key: 'valorSuspenso',
          label: 'Valor Suspenso',
          sortable: true,
          class: 'text-right',
        },
      ],
    }
  },
  mounted() {
    this.$bvModal.show('suspensoes-mit')
    this.carregarSuspensoes()
  },
  methods: {
    fecharModal() {
      this.$emit('hidden')
    },

    carregarSuspensoes() {
      this.carregando = true

      const filtroBody = {
        empresas: [this.empresaId],
        filtroBy: [
          { colunas: ['IdApuracao'], valor: this.idApuracao },
        ],
        ordemBy: [],
      }

      service.getSuspensoes(this.pagina, this.tamanhoPagina, filtroBody)
        .then(({ data }) => {
          this.dados = data || null

          // Processa a resposta do backend (seguindo padrão do DebitosView)
          const getValores = resp => {
            if (Array.isArray(resp?.Valores)) return resp.Valores
            if (Array.isArray(resp?.valores)) return resp.valores
            if (Array.isArray(resp?.dados)) return resp.dados
            if (resp?.dados && typeof resp.dados === 'object') return [resp.dados]
            return []
          }

          const valores = getValores(data)

          // Filtra por empresa e apuração quando disponíveis
          const byEmpresa = valores.filter(v => {
            const emp = Number(v.EmpresaId ?? v.empresaId)
            return !Number.isNaN(emp) && emp === Number(this.empresaId)
          })

          const pool = byEmpresa.length ? byEmpresa : valores
          const entry = pool.find(v => {
            const ap = Number(v.IdApuracao ?? v.idApuracao)
            return !Number.isNaN(ap) && ap === Number(this.idApuracao)
          }) || pool[0] || null

          // Extrai as suspensões do entry encontrado
          if (entry && entry.suspensoes) {
            this.suspensoes = Array.isArray(entry.suspensoes) ? entry.suspensoes : []
          } else {
            this.suspensoes = []
          }
        })
        .catch(error => {
          this.$erro('Erro ao carregar suspensões:', error)
          this.dados = null
          this.suspensoes = []
        })
        .finally(() => {
          this.carregando = false
        })
    },

    obterDescricaoTipo(tipo) {
      // Mapeia os tipos de suspensão conforme a regra de negócio
      const tipos = {
        1: 'Judicial',
        2: 'Administrativa',
        3: 'Liminar',
        4: 'Outros',
      }
      return tipos[tipo] || `Tipo ${tipo}`
    },

    obterDescricaoMotivo(motivo) {
      // Mapeia os motivos de suspensão conforme a regra de negócio
      const motivos = {
        1: 'Contestação Judicial',
        2: 'Processo Administrativo',
        3: 'Liminar Concedida',
        4: 'Recurso em Andamento',
        5: 'Outros',
      }
      return motivos[motivo] || `Motivo ${motivo}`
    },

    obterDescricaoVara(vara) {
      // Mapeia as varas judiciárias conforme necessário
      const varas = {
        1: '1ª Vara Federal',
        2: '2ª Vara Federal',
        3: '3ª Vara Federal',
        4: 'Vara Estadual',
        5: 'Tribunal Superior',
      }
      return varas[vara] || `Vara ${vara}`
    },

    formatarData(data) {
      // Formata data no formato YYYYMMDD para DD/MM/YYYY
      if (!data) return ''

      const dataStr = String(data)
      if (dataStr.length === 8) {
        const ano = dataStr.substring(0, 4)
        const mes = dataStr.substring(4, 6)
        const dia = dataStr.substring(6, 8)
        return `${dia}/${mes}/${ano}`
      }

      return dataStr
    },

    formatarValor(valor) {
      // Formata o valor como moeda brasileira
      if (!valor || valor === 0) return 'R$ 0,00'

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(valor)
    },

    calcularTotalSuspenso(debitosSuspensos) {
      // Calcula o total dos valores suspensos
      if (!Array.isArray(debitosSuspensos)) return 0

      return debitosSuspensos.reduce((total, debito) => {
        const valor = Number(debito.valorSuspenso || 0)
        return total + (Number.isFinite(valor) ? valor : 0)
      }, 0)
    },
  },
}
</script>
